import { EcommerceConfig } from 'idt-ecommerce-api/config/config.models';


/**
 * This class will be used only among services in the ecommerce-api module, to prevent cyclic dependencies.
 * For the rest of the application, use the 'config' object in ContextService.
 */
export class EcommerceConfigService {

  private config: EcommerceConfig | undefined;

  public getConfig(): EcommerceConfig {
    if (this.config === undefined) {
      throw new Error('EcommerceConfigService: config not set');
    }

    return this.config;
  }

  public setConfig(config: EcommerceConfig): void {
    this.config = config;
  }

}
